exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.product__small__images {\r\n  max-width: 150px;\r\n}\r\n\r\n/*img {*/\r\n  /*cursor: pointer;*/\r\n/*}*/\r\n\r\nfigure.zoom {\r\n  background-position: 50% 50%;\r\n  position: relative;\r\n  width: 500px;\r\n  overflow: hidden;\r\n  cursor: zoom-in;\r\n}\r\nfigure.zoom img:hover {\r\n  opacity: 0;\r\n}\r\nfigure.zoom img {\r\n  transition: opacity .5s;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n\r\nngx-image-zoom img{\r\n  width:400px !important;\r\n}\r\n\r\n.xzoom{\r\n  box-shadow: none !important;\r\n  /* box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5); */\r\n}\r\n\r\n.main-imgg{\r\n  opacity: 1;\r\n  transition: all 2s ease-in-out;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/container/product-details/product-images/product-images.component.css
// module id = ../../../../../src/app/container/product-details/product-images/product-images.component.css
// module chunks = main